import { motion } from 'framer-motion';

const FadeInSection = ({ children, delay = 0,  direction = 'up' }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, delay }}
  >
    {children}
  </motion.div>
);

export default FadeInSection;